import './bootstrap';

// import 'vuetify/styles';
// import '@fortawesome/fontawesome-free/scss/fontawesome.scss';
// import '@fortawesome/fontawesome-free/scss/brands.scss';
// import '@fortawesome/fontawesome-free/scss/regular.scss';
// import '@fortawesome/fontawesome-free/scss/solid.scss';
// import '@fortawesome/fontawesome-free/scss/v4-shims.scss';
import '../css/app.scss';

import { createApp, h, DefineComponent, App } from 'vue';
import { createInertiaApp, Link } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue, route } from '../../vendor/tightenco/ziggy/src/js';
import { createPinia } from 'pinia';
import MdiIcon from '@/Components/icons/MdiIcon.vue';
import FormLabel from '@/Components/vuetify/FormLabel.vue';
import Divider from '@/Components/Divider.vue';
import appConfig from './Config/default';
import Vue3Toastify, { type ToastContainerOptions } from 'vue3-toastify';
import { setupInertiaErrorHandler } from '@/Plugins/error-handler';
import vuetify from './Plugins/vuetify';
import AppLayout from '@/Layouts/AppLayout.vue';
import Error from '@/Pages/Error.vue';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: import.meta.env.VITE_PUSHER_APP_KEY,
    cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
    forceTLS: true,
    // encrypted: true,
});

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

// Define the type for the page component
type PageComponent = DefineComponent & {
    default: {
      layout?: typeof AppLayout;
      props?: Record<string, any>;
      // Define other properties/methods if necessary
    };
};
createInertiaApp({
    title: (title) => `${title ? `${title} - ` : ``}${appName}`,
    resolve: (name: string): PageComponent => {
        const pages: Record<string, PageComponent> = import.meta.glob('./Pages/**/*.vue', { eager: true });
        const page = pages[`./Pages/${name}.vue`] as PageComponent;
    
        // Set default layout if it is not already specified
        page.default.layout = page.default.layout || AppLayout;
        if (page.default.props) {
            // Set additional props here if needed
            page.default.props.title = page.default.props.title || 'Default Title';
        }
    
        return page;
    },
    // resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'))  as Promise<DefineComponent>,
    setup: ({ el, App, props, plugin }) => {
        const pinia = createPinia();
        const app = createApp({ render: () => h(App, props) });
        app.config.globalProperties.$route = route;
        app.use(plugin)
            .use(ZiggyVue)
            .use(vuetify)
            .use(pinia)
            .use(
                Vue3Toastify,
                {
                  autoClose: 5000,
                  dangerouslyHTMLString: true,
                  // ...
                } as ToastContainerOptions,
            )
            .component('Link', Link)
            .component('Error', Error)
            .component('MdiIcon', MdiIcon)
            .component('FormLabel', FormLabel)
            .component('Divider', Divider)
            .mount(el);

            setupInertiaErrorHandler(app);
    },
    progress: {
        color: '#61a3e3',
    },
});
